import { forwardRef } from 'react';
import { cva, cx, VariantProps } from 'class-variance-authority';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';
import { Typography } from './Typography';

export const ball = cva(
  ['rounded-full', 'inline-flex', 'items-center', 'justify-center'],
  {
    variants: {
      color: {
        primary: ['bg-primary-800'],
        neutral: ['bg-neutral-200'],
      },
      size: {
        sm: ['w-8', 'h-8'],
        lg: ['w-12', 'h-12'],
      },
      dimmed: {
        true: [],
        false: [],
      },
    },
    compoundVariants: [
      {
        color: 'primary',
        className: 'text-white',
      },
      { color: 'neutral', dimmed: false, className: 'text-neutral-700' },
      { color: 'neutral', dimmed: true, className: 'text-neutral-400' },
    ],
    defaultVariants: {
      color: 'primary',
    },
  }
);

type HeadingNumberTypeMap = BaseTypeMap<'div', VariantProps<typeof ball>>;

export type HeadingNumberProps = ComponentProps<HeadingNumberTypeMap>;

export const HeadingNumber: Component<HeadingNumberTypeMap> = forwardRef(
  function HeadingNumber(
    { children, className, size = 'lg', color, dimmed, ...rest },
    ref
  ) {
    return (
      <Box
        ref={ref}
        className={cx(ball({ size, color, dimmed }), className)}
        {...rest}
      >
        <Typography
          as="p"
          intent={size === 'lg' ? 'headline' : 'title'}
          size={size === 'lg' ? 'sm' : size}
        >
          {children}
        </Typography>
      </Box>
    );
  }
);
